import React from 'react';
import { SectionWrapper } from './SectionWrapper';
import { Thermometer, Zap, ClipboardX } from 'lucide-react';

const ProblemSection: React.FC = () => {
  return (
    <SectionWrapper>
      <div className="flex flex-col items-center text-center max-w-3xl mx-auto mb-10 md:mb-16">
        <h2 className="text-2xl md:text-5xl font-black mb-6 md:mb-8 text-primary tracking-tight leading-tight">
          Baustaub ist ein häufiger Grund für Verzögerungen.
        </h2>
        
        <p className="text-sm md:text-lg text-gray-600 leading-relaxed px-2">
          Als Bauleiter haften Sie für die Sicherheit der Anlagen. Bei Umbauten im laufenden Betrieb (<span className="text-accent font-bold italic">«Running Systems»</span>) 
          reichen herkömmliche Folien nicht aus.
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-8">
        <div className="p-6 md:p-10 bg-white rounded-xl border border-divider shadow-sm flex flex-col items-center text-center">
          <div className="w-12 h-12 md:w-16 md:h-16 bg-red-50 rounded-xl flex items-center justify-center mb-5">
            <Thermometer className="w-6 h-6 md:w-8 md:h-8 text-red-500" />
          </div>
          <h3 className="text-lg md:text-xl font-bold mb-3 text-primary">Thermisches Risiko</h3>
          <p className="text-xs md:text-base text-gray-600 leading-relaxed">
            Abdeckungen führen oft zu Wärmestau und Hardwareschäden. Die Haftung ist in solchen Fällen oft ungeklärt.
          </p>
        </div>

        <div className="p-6 md:p-10 bg-white rounded-xl border border-divider shadow-sm flex flex-col items-center text-center">
          <div className="w-12 h-12 md:w-16 md:h-16 bg-red-50 rounded-xl flex items-center justify-center mb-5">
            <Zap className="w-6 h-6 md:w-8 md:h-8 text-red-500" />
          </div>
          <h3 className="text-lg md:text-xl font-bold mb-3 text-primary">Leitfähige Beläge</h3>
          <p className="text-xs md:text-base text-gray-600 leading-relaxed">
            Feinstaub dringt in Platinen ein. Folge: Korrosion und Kriechströme – oft erst Wochen nach Projektabschluss.
          </p>
        </div>

        <div className="p-6 md:p-10 bg-white rounded-xl border border-divider shadow-sm flex flex-col items-center text-center">
          <div className="w-12 h-12 md:w-16 md:h-16 bg-red-50 rounded-xl flex items-center justify-center mb-5">
            <ClipboardX className="w-6 h-6 md:w-8 md:h-8 text-red-500" />
          </div>
          <h3 className="text-lg md:text-xl font-bold mb-3 text-primary">Abnahme-Mängel</h3>
          <p className="text-xs md:text-base text-gray-600 leading-relaxed">
            Verschmutzte Technik gilt als Baumangel. Das führt zu teurer Nachreinigung und verzögert die Übergabe.
          </p>
        </div>
      </div>
    </SectionWrapper>
  );
};

export default ProblemSection;